export default function chatbots(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
      return {
        ...state,
        chatbot: action.chatbot,
      }
    default:
      return state;
  }
}